import { render, staticRenderFns } from "./part_menu.vue?vue&type=template&id=f68d433e&scoped=true&"
import script from "./part_menu.vue?vue&type=script&lang=js&"
export * from "./part_menu.vue?vue&type=script&lang=js&"
import style0 from "./part_menu.vue?vue&type=style&index=0&id=f68d433e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f68d433e",
  null
  
)

export default component.exports